import { render, staticRenderFns } from "./PopularProductsReport.vue?vue&type=template&id=4fce3754&"
import script from "./PopularProductsReport.vue?vue&type=script&lang=js&"
export * from "./PopularProductsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports